import React from 'react'
import classNames from 'classnames'
import styles from './styles.css'
import SMSIcon from '#src/components/Share/share-sms.svg'
import FacebookIcon from '#src/components/Share/share-facebook.svg'
import LinkIcon from '#src/components/Share/share-link.svg'
import EmailIcon from '#src/components/Share/share-email.svg'
import { ShareVariant } from '../ShareSellableFooter'

interface IconBoxProps {
  onClick: () => void
  variant: ShareVariant
}

const FacebookIconBox: React.SFC<IconBoxProps> = ({ variant, onClick }) => {
  return (
    <div
      className={classNames(styles.facebookBox, {
        [styles.responsiveShareBoxNoBorder]: variant === 'responsive',
        [styles.largeShareBoxNoBorder]: variant === 'large',
        [styles.smallShareBoxNoBorder]: variant === 'small'
      })}
      onClick={onClick}
    >
      <FacebookIcon />
    </div>
  )
}

const EmailIconBox: React.SFC<IconBoxProps> = ({ variant, onClick }) => {
  return (
    <div
      className={classNames(styles.emailBox, {
        [styles.responsiveShareBox]: variant === 'responsive',
        [styles.largeShareBox]: variant === 'large',
        [styles.smallShareBox]: variant === 'small'
      })}
      onClick={onClick}
    >
      <EmailIcon />
    </div>
  )
}

const LinkIconBox: React.SFC<IconBoxProps> = ({ variant, onClick }) => {
  return (
    <div
      className={classNames(styles.linkBox, {
        [styles.responsiveShareBox]: variant === 'responsive',
        [styles.largeShareBox]: variant === 'large',
        [styles.smallShareBox]: variant === 'small'
      })}
      onClick={onClick}
    >
      <LinkIcon />
    </div>
  )
}

const SMSIconBox: React.SFC<IconBoxProps> = ({ variant, onClick }) => {
  return (
    <div
      className={classNames(styles.smsBox, {
        [styles.responsiveShareBox]: variant === 'responsive',
        [styles.largeShareBox]: variant === 'large',
        [styles.smallShareBox]: variant === 'small'
      })}
      onClick={onClick}
    >
      <SMSIcon />
    </div>
  )
}

export { SMSIconBox, LinkIconBox, EmailIconBox, FacebookIconBox }
